/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
import { isBrowser } from './env';
import { openLink } from './jsBridge';

export const goWithdraw = (coin: string) => {
  const baseLink = 'bybitapp://open/withdraw';
  const search = coin ? `?coin=${coin}` : '';
  openLink(`${baseLink}${search}`);
};

export const goBuy = () => {
  openLink('bybitapp://open/fiat/buycrypto');
};

export const goSwap = () => {
  openLink('by://web3/tab/index?tag=swap');
};

export const goDeposit = (coin: string) => {
  const baseLink = 'bybitapp://open/recharge';
  const search = coin ? `?coin=${coin}` : '';
  openLink(`${baseLink}${search}`);
};

export const goTransfer = (coin: string) => {
  const baseLink = 'bybitapp://open/transfer';
  const search = coin ? `?coin=${coin}` : '';
  openLink(`${baseLink}${search}`);
};

interface ReceiveProps {
  chainCode: string;
  coinName: string;
  address: string;
}

export const goReceive = (params?: ReceiveProps) => {
  const keys = ['chainCode', 'coinName', 'address'];
  const search = keys
    .filter((key) => (params || {})[key])
    // @ts-ignore
    .map((key) => `${key}=${params[key]}`)
    .join('&');

  const link = `bybitapp://open/route?targetUrl=by://web3/wallet/receive${search ? `?${search}` : ''}`;
  openLink(link);
};

interface SendProps {
  chainCode: string;
  coinName: string;
  address: string;
  walletAddress: string;
}

export const goSend = (params?: SendProps) => {
  const keys = ['chainCode', 'coinName', 'address', 'walletAddress'];
  const search = keys
    .filter((key) => (params || {})[key])
    // @ts-ignore
    .map((key) => `${key}=${params[key]}`)
    .join('&');

  const link = `bybitapp://open/route?targetUrl=by://web3/wallet/send${search ? `?${search}` : ''}`;
  openLink(link);
};

export const goSwapDetail = (tokenId: string) => {
  const link = `by-mini://web3_applet/swap_token_detail?tokenId=${tokenId}`;
  openLink(link);
};

export const BybitWalletChromeExtensionLink =
  'https://chromewebstore.google.com/detail/bybit-wallet/pdliaogehgdbhbnmkklieghmmjkpigpa';

/**
 * 创建bybit当前域名地址
 * @description 支持多域名，xxx.bybit.com => xxx.bybitglobal.com
 */
export const createBybitUrl = (url: string) => {
  if (!isBrowser) return url;
  if (!url) return '';
  /** 无域名直接返回 */
  if (url.startsWith('/')) return url;
  const { protocol, hostname, pathname, search } = new URL(url);
  /** bybit域名进行转换 */
  if (hostname.endsWith('bybit.com')) {
    const domain = isBrowser
      ? window.location.hostname.split('.').slice(-2).join('.')
      : 'bybit.com';
    const prev = hostname.split('.')[0];
    return `${protocol}//${prev}.${domain}${pathname}${search}`;
  }
  /** 其它域名不做处理 */
  return url;
};

/**
 * 当你需要跳转一个可能是应用内、或应用外（不是当前那个效能应用）站内其它业务连接、甚至站外链接时，就用这个方法
 * 兼容各个情况
 * @param url 目标url
 * @param option.type 如何跳转 新窗、刷新、或者pushState（默认）
 * @param option.replace push 的情况下是否是 replaceState
 * @param option.state pushState 的状态
 * @returns
 */
export const web3Navigate = (
  url?: string,
  {
    type = 'push',
  }: {
    type?: 'reload' | 'blank' | 'push';
    replace?: boolean;
    state?: unknown;
  } = {}
) => {
  if (!url || !isBrowser) return;

  const location = window.location;
  if (type === 'blank') {
    window.open(url, '_blank');
    return;
  } else if (type === 'reload') {
    location.href = url;
    return;
  }

  const { hostname } = location;
  if (url.indexOf(hostname) > -1 || url.indexOf('bybit.com') > -1) {
    location.href = url;
    return;
  }
  if (url.startsWith('http://') || url.startsWith('https://')) {
    window.open(url, '_blank');
    return;
  }
  location.href = url;
};
